import styled from "styled-components";

interface iLabelProps {
    border?: boolean;
}

export const Label = styled.label<iLabelProps>`
    font-size: ${props => props.border ? `0.89rem` : `1rem`}; ;
    color: ${props => props.border ?
        props => props.theme.colors.typography2.medium :
        props => props.theme.colors.typography1.dark};
   
    border: ${props => props.border ?
        `1px solid ${props.theme.colors.typography1.dark} ` :
        `none`};  
    border-radius: ${props => props.border ? `12px` : `none`};
    padding: ${props => props.border ? `8px` : `none`}; 
    margin-bottom: ${props => props.border ? `18px` : `2px`}; 

    &.labelSearch{
        display: flex;
    }

    &.errorColor{
        border-color: #D66157;
    }

    &.disabled{
        background-color: #757575;
    }

    > span {
        font-weight: 500;
        font-size: 0.9rem;
        line-height: 30px;
        color: ${props => props.theme.colors.typography2.medium};
    }
`